import { useCallback, useState } from 'react';
import { usePostFavoriteMarket } from '../queries/usePostFavoriteMarket';
import { useDeleteFavoriteMarket } from '../queries/useDeleteFavoriteMarket';
import { useLogClickFavoriteMarket } from './useLogClickFavoriteMarket';

export const useOnPressFavoriteMarket = (params: {
  sno?: number;
  // marketName: string;
  // listId: string;
  favorite: boolean;
}) => {
  const [loadingLogClickFavoriteMarket, setLoadingLogClickFavoriteMarket] =
    useState(false);

  const logClickFavoriteMarket = useLogClickFavoriteMarket();

  const {
    mutateAsync: postFavoriteMarket,
    isPending: loadingPostFavoriteMarket,
  } = usePostFavoriteMarket(params.sno);

  const {
    mutateAsync: deleteFavoriteMarket,
    isPending: loadingDeleteFavoriteMarket,
  } = useDeleteFavoriteMarket(params.sno);

  return {
    action: useCallback(async () => {
      if (params.favorite) {
        setLoadingLogClickFavoriteMarket(true);
        await logClickFavoriteMarket(true);
        setLoadingLogClickFavoriteMarket(false);
        return deleteFavoriteMarket();
      } else {
        setLoadingLogClickFavoriteMarket(true);
        await logClickFavoriteMarket(false);
        setLoadingLogClickFavoriteMarket(false);
        return postFavoriteMarket();
      }
    }, [
      params.favorite,
      logClickFavoriteMarket,
      deleteFavoriteMarket,
      postFavoriteMarket,
    ]),
    loading:
      loadingPostFavoriteMarket ||
      loadingDeleteFavoriteMarket ||
      loadingLogClickFavoriteMarket,
  };
};
